<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">RECIBOS CADETES</h1>
        </section>

        <section id="table">
            <mat-card class="mat-elevation-z0">
                <form [formGroup]="receiptForm" (ngSubmit)="search(receiptForm.value)">
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="25">
                            <mat-form-field appearance="outline">
                                <mat-label>Cadete</mat-label>
                                <mat-select formControlName="cadete" required>
                                    <mat-option *ngFor="let delivery of allDeliveries" [value]="delivery.cdDelivery">
                                        {{delivery.dsName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="receiptForm.controls['cadete'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="25">
                            <mat-form-field appearance="outline">
                                <mat-label>Fecha</mat-label>
                                <input matInput [matDatepicker]="picker1" formControlName="date" readonly>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div fxFlex="25">
                            <mat-form-field appearance="outline">
                                <mat-label>Nº comprobante</mat-label>
                                <input matInput formControlName="receipt" readonly>
                            </mat-form-field>
                        </div>
                        <div fxFlex="25">
                            <mat-form-field appearance="outline">
                                <mat-label>Importe</mat-label>
                                <input matInput required formControlName="amount">
                                <mat-error *ngIf="receiptForm.controls['amount'].hasError('required')">
                                    Este campo es obligatorio
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button mat-flat-button class="squared-btn">Confirmar cabecera</button>
                    </div>
                    <br>
                </form>
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">

                    <ng-container matColumnDef="order">
                        <th mat-header-cell *matHeaderCellDef class="table-header">PEDIDO</th>
                        <td mat-cell *matCellDef="let order"> {{order.cdOrder}} </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef class="table-header">FECHA</th>
                        <td mat-cell *matCellDef="let order"> {{order.dtCreated | date: 'short'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="client">
                        <th mat-header-cell *matHeaderCellDef class="table-header">CLIENTE</th>
                        <td mat-cell *matCellDef="let order"> {{order.dsName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL</th>
                        <td mat-cell *matCellDef="let order"> {{order.qtTotal}} </td>
                    </ng-container>

                    <ng-container matColumnDef="received">
                        <th mat-header-cell *matHeaderCellDef class="table-header">RECIBIDO</th>
                        <td mat-cell *matCellDef="let order"> {{order.qtMontoRecibo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="pending">
                        <th mat-header-cell *matHeaderCellDef class="table-header">PENDIENTE</th>
                        <td mat-cell *matCellDef="let order"> {{order.qtTotal - order.qtMontoRecibo}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <br>
                <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                    <div fxLayout="column" fxFlex="70">
                        <mat-form-field appearance="outline" class="formField">
                            <mat-label>OBSERVACIONES</mat-label>
                            <textarea matInput [(ngModel)]="observaciones"></textarea>
                        </mat-form-field>
                    </div>
                    <div fxLayout="column" fxFlex="30">
                        <mat-form-field appearance="outline" class="formField">
                            <mat-label>Total</mat-label>
                            <input disabled matInput value="{{total}}">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="formField">
                            <mat-label>Pendiente</mat-label>
                            <input disabled matInput value="{{pending}}">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="formField">
                            <mat-label>Recibido</mat-label>
                            <input disabled matInput value="{{recibido}}">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="formField">
                            <mat-label>Saldo</mat-label>
                            <input disabled matInput value="{{saldo}}">
                        </mat-form-field>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <br>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
                    <div fxFlex="30">
                        <mat-form-field appearance="outline" class="formField">
                            <mat-label>Contraseña</mat-label>
                            <input type="password" matInput required [(ngModel)]="password">
                        </mat-form-field>
                    </div>
                    <div>
                        <button mat-flat-button class="squared-btn" (click)="confirm()">Emitir recibo</button>
                    </div>
                </div>
            </mat-card>
        </section>
    </div>
</div>